module.exports = __webpack_public_path__ + "static/img/floor.1657b6bc.png";